import CourseCard from 'components/CourseDashboard/CourseCard';
import { Text } from 'shell/components';

const CourseCardDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>CourseCard</Text>
            <CourseCard
                key={1}
                className={''}
                course={{
                    course_id: '1',
                    name: 'Course 1',
                    description: 'Description 1',
                    start_date: '2022-01-01',
                    end_date: '2022-01-02',
                }}
                handleCourseCardDropdown={() => console.log('open course dropdown')}
                onClick={() => console.log('open course')}
            />
        </>
    );
};

export default CourseCardDemo;
